import type { QueryClient } from "@tanstack/react-query";

// Invalidate EVERY EEX data query after a mutation. A prefix predicate (rather than
// an explicit key list) means a query key can never be silently forgotten — the bug
// this fixes was that mutations invalidated only one positions query, so the
// positions-tree/leaf pages (["eex-positions-tree"], ["eex-positions-leaf"]) and the
// P&L / Matching pages (["eex-recognition-months"], ["eex-worklist"]) kept showing
// pre-mutation figures within their staleTime.
export function invalidateEexData(qc: QueryClient): void {
  void qc.invalidateQueries({
    predicate: (q) =>
      typeof q.queryKey[0] === "string" && (q.queryKey[0] as string).startsWith("eex-"),
  });
}

// Mark every affected report stale, but refresh only the workspace being used.
// Reopening P&L/Positions still fetches fresh data without starting them all
// again while an administrator is editing the next recognition result.
export function invalidateRecognitionData(qc: QueryClient): void {
  void qc.invalidateQueries({ predicate: (q) => typeof q.queryKey[0] === "string" && q.queryKey[0].startsWith("eex-"), refetchType: "none" });
  void qc.refetchQueries({ queryKey: ["eex-recognition-schedules"], type: "active" });
}
